import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ITeklifHareketleri_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeklifHareketleri_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetTeklifHareketleri: any[];
  GetTeklifHareketleri_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
}

export class TeklifHareketleri_ScreenBase extends React.PureComponent<
  ITeklifHareketleri_ScreenProps,
  any
> {
  teklifhareketleri_58290_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 410871,
          PropertyName: "value",
          Value: "REVISED QUOTATION BACKGROUND LIST ",
          TagName: "Label32_value",
        },
        {
          Id: 193926,
          PropertyName: "value",
          Value: "LIST ALL REVISED ON YOUR QUOTATION",
          TagName: "Label39_value",
        },
        {
          Id: 824789,
          PropertyName: "title",
          Value: "DATE",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 252170,
          PropertyName: "title",
          Value: "REVISED NUMBER",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 43329,
          PropertyName: "title",
          Value: "CUSTOMER REPRESENTATIVE",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 635294,
          PropertyName: "title",
          Value: "DETAILS",
          TagName: "TableTemplateColumn4_title",
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 410871,
          PropertyName: "value",
          Value: "Historique des révisions d'offre",
          TagName: "Label32_value",
        },
        {
          Id: 193926,
          PropertyName: "value",
          Value:
            "Vous pouvez voir les révisions apportées à votre offre dans l'ordre suivant",
          TagName: "Label39_value",
        },
        {
          Id: 824789,
          PropertyName: "title",
          Value: "Date",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 252170,
          PropertyName: "title",
          Value: "Numéro de révision",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 43329,
          PropertyName: "title",
          Value: "Plasiyer",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 635294,
          PropertyName: "title",
          Value: "Détails",
          TagName: "TableTemplateColumn4_title",
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 410871,
          PropertyName: "value",
          Value: "Historial de revisiones de la cotización",
          TagName: "Label32_value",
        },
        {
          Id: 193926,
          PropertyName: "value",
          Value:
            "Puedes ver las revisiones realizadas a tu cotización en el orden en que se realizaron.",
          TagName: "Label39_value",
        },
        {
          Id: 824789,
          PropertyName: "title",
          Value: "Fecha",
          TagName: "TableTemplateColumn1_0_title",
        },
        {
          Id: 252170,
          PropertyName: "title",
          Value: "Número de secuencia de revisión",
          TagName: "TableTemplateColumn2_title",
        },
        {
          Id: 43329,
          PropertyName: "title",
          Value: "Vendedor",
          TagName: "TableTemplateColumn3_title",
        },
        {
          Id: 635294,
          PropertyName: "title",
          Value: "Detalles",
          TagName: "TableTemplateColumn4_title",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "8cdcca05-30f9-4bed-b40c-718a5c5ff39c",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 410871,
          PropertyName: "value",
          Value: "Teklif Revize Geçmişi Listesi",
        },
        {
          Id: 193926,
          PropertyName: "value",
          Value:
            "Teklifinize ait hangi revizeler yapılmış sırasıyla görebilirsiniz",
        },
        { Id: 824789, PropertyName: "title", Value: "Tarih" },
        { Id: 395572, PropertyName: "value", Value: "[datafield:tarih]" },
        { Id: 252170, PropertyName: "title", Value: "Revize Sıra Numarası" },
        {
          Id: 491050,
          PropertyName: "value",
          Value: "[datafield:siranumarasi]",
        },
        { Id: 43329, PropertyName: "title", Value: "Plasiyer" },
        { Id: 422872, PropertyName: "value", Value: "[datafield:plasiyer]" },
        { Id: 635294, PropertyName: "title", Value: "Detay" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.teklifhareketleri_58290_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetTeklifHareketleri: [],
      NAVIGATE: "",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("teklifhareketleri", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.TeklifHareketleriPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teklifhareketleri", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teklifhareketleri", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeklifHareketleriPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeklifHareketleriPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.TeklifNumarasi ??
          this.props.screenInputs.teklifnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifHareketleri/TeklifHareketleriPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTeklifHareketleri = result?.data.getTeklifHareketleri;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifHareketleriPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifHareketleriPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_58290 =
      stateVars.GetTeklifHareketleri ?? this.state.GetTeklifHareketleri;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TeklifHareketleriComponent_668542_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TeklifHareketleriStoklar",
      "TeklifNumarasi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifhareketleri_58290_value",
          "teklifNumarasi"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TeklifHareketleriStoklar",
      "siraNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifhareketleri_58290_value",
          "siraNumarasi"
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifHareketleri",
      "TeklifHareketleriStoklar",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "311028",
      null,
      null,
      "true",
      "1600px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [311028] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TeklifHareketleriPageInit();
    }
  }
}
